function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-07435076-f36c-408b-8175-077dfdb050c6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m27.332,13.022H10.699c-1.655,0-3.001,1.347-3.001,3.001v4.707l-3.002-7.574c-.084-.213.02-.454.232-.538l14.695-5.824c.213-.083.454.02.538.232l1.514,3.819c.305.771,1.177,1.146,1.947.842.77-.305,1.147-1.177.842-1.947l-1.514-3.819c-.693-1.75-2.68-2.611-4.432-1.916L3.823,9.83c-1.75.694-2.609,2.682-1.916,4.432l3.089,7.795c.468,1.18,1.526,1.953,2.702,2.12v1.057c0,1.655,1.346,3.002,3.001,3.002h16.632c1.655,0,3.001-1.347,3.001-3.002v-9.209c0-1.655-1.346-3.001-3.001-3.001Zm.001,3.001v1.397s-16.634,0-16.634,0v-1.398s16.634.001,16.634.001Zm-16.635,9.209v-4.812h16.635v4.814s-16.635-.002-16.635-.002Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.647,
    y: 21.241,
    width: 2.942,
    height: 2.943,
    rx: 0.728,
    ry: 0.728,
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.52c6c31b0ac8d4e000315b04523888fa.svg";
export { ForwardRef as ReactComponent };